import { useMemo } from "react";
import clsx from "clsx";
import type { CoverageRow } from "./quizReportApi";
import { SET_SIZE } from "./constants";

/**
 * Modül × konu soru sayıları. Amaç: bankadaki boşlukları görmek —
 * hangi modül yeterli soruya sahip değil, hangi konu zayıf kalmış.
 */
export default function CoverageTable({ rows }: { rows: CoverageRow[] }) {
  const byModule = useMemo(() => {
    const map = new Map<number, CoverageRow[]>();
    for (const r of rows) {
      const list = map.get(r.module_id) ?? [];
      list.push(r);
      map.set(r.module_id, list);
    }
    return [...map.entries()].sort((a, b) => a[0] - b[0]);
  }, [rows]);

  return (
    <div className="flex flex-col gap-6">
      {byModule.map(([moduleId, topics]) => {
        const total = topics.reduce((s, t) => s + t.total, 0);
        const withTests = topics.reduce((s, t) => s + t.with_tests, 0);
        const testCount = topics.reduce((s, t) => s + t.test_count, 0);
        // Set 20 soruluk; bankada en az bu kadar olmalı yoksa kart hiç görünmez
        const ready = total >= SET_SIZE;

        return (
          <div key={moduleId} className="bg-myGb/20 rounded-2xl p-4">
            <div className="flex items-center gap-3 mb-3">
              <span className="font-semibold">Modül {moduleId}</span>
              <span
                className={clsx(
                  "text-[11px] font-bold tracking-wider px-2 py-0.5 rounded-full",
                  ready ? "bg-myGreen/15 text-myGreen" : "bg-myRed/15 text-myRed",
                )}
              >
                {ready ? "HAZIR" : `YETERSİZ (${total}/${SET_SIZE})`}
              </span>
              <span className="text-xs text-white/40">
                {topics.length} konu · {total} soru · {testCount} çoktan seçmeli ·{" "}
                {withTests} gizli testli
              </span>
            </div>

            <div className="overflow-x-auto">
              <table className="w-full text-sm min-w-[520px]">
                <thead>
                  <tr className="text-white/40 text-xs text-left">
                    <th className="pb-1 font-medium">Konu</th>
                    <th className="pb-1 font-medium w-16 text-right">Soru</th>
                    <th className="pb-1 font-medium w-24 text-right">Zorluk 1/2/3</th>
                    <th className="pb-1 font-medium w-20 text-right">Gizli test</th>
                  </tr>
                </thead>
                <tbody>
                  {topics.map((t) => (
                    <tr key={t.code} className="border-t border-white/5">
                      <td className="py-1.5">
                        <span className="text-white/80">{t.title}</span>
                        <span className="text-white/25 text-xs ml-2">{t.code}</span>
                      </td>
                      <td
                        className={clsx(
                          "text-right",
                          t.total < 4 ? "text-myRed font-semibold" : "text-white/60",
                        )}
                      >
                        {t.total}
                      </td>
                      <td className="text-right text-white/40 text-xs">
                        {t.d1}/{t.d2}/{t.d3}
                      </td>
                      <td className="text-right text-white/40 text-xs">{t.with_tests}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        );
      })}
    </div>
  );
}
